import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { majorRoles } from '../constants/keys.constant';

@Pipe({
  standalone: true,
  name: 'roleName'
})
export class RoleNamePipe implements PipeTransform {


  protected majorRoles = majorRoles;
  constructor(private translateService: TranslateService) {}

  transform(packageType: number | undefined): string {
    switch (packageType) {
    case this.majorRoles.ADMIN:
      return 'Admin';
    case this.majorRoles.STUDENT:
      return this.translateService.instant('Student');
    case this.majorRoles.TUTOR:
      return this.translateService.instant('Tutor');
    case this.majorRoles.COUNSELOR:
      return this.translateService.instant('Counsellor');
    case this.majorRoles.PARENT:
      return this.translateService.instant('Parent');
    case this.majorRoles.SUBADMIN:
      return this.translateService.instant('Sub-admin');
    default:
      return '';
    }
  }
}

